import React from "react";
import "./AcornSelfPublishing.css";
import ComparisonTable from "../../../Shared/ComparisonTable/ComparisonTable";

const recommendedForData = [
  "1인 기업가, 강사, 전문가 등 자기 브랜드를 구축하고 싶은 분",
  "모든 출판 과정에 직접 참여하고 싶은 분",
  "소량 제작이나 소규모 독립 출판을 원하는 분",
  "SNS·커뮤니티 기반으로 팬층에 책을 판매하고 싶은 분",
  "빠르게 책을 만들어 콘텐츠를 자산화하고 싶은 분",
  "출판사 투고 없이 내 일정대로 책을 내고 싶은 분"
];

const whatToPrepareData = [
  {
    title: "완성된 원고",
    description: "Word 파일 원고\nA5 기준 150~200페이지 이상 권장",
  },
  {
    title: "저자 소개서 및 이력",
    description: "책의 신뢰도와\n마케팅 활용도를 높이는 데 중요한 요소",
  },
  {
    title: "출판 목적과 타겟 독자 설정",
    description: "책의 기획 방향과\n마케팅 전략의 기반",
  },
  {
    title: "예산 계획",
    description: "평균 200 ~ 500만 원",
  },
  {
    title: "마케팅 계획",
    description: "SNS, 독자 대상 이벤트,\n광고, 보도자료 등",
  },
];

const AcornSelfPublishing = ({ setActiveStepIndex }) => {
  const handleClick = () => {
    setActiveStepIndex(2); // 출판 컨설팅 탭으로 이동
    window.scrollTo({ top: 0, behavior: "smooth" }); // 상단으로 부드럽게 이동
  };
  
  return (
    <section className="acorn-publishing-section">
      <div className="intro-section">
        <h1 className="section-title">자비 출판이란 무엇인가요?</h1>
        <p className="section-description">
          자비 출판은 저작자가 출판비용을 부담하여 책을 출판하는 방식입니다.
          <br />
          저작자가 모든 비용을 지불하는 대신, 수익을 100% 보유할 수 있습니다.
        </p>
      </div>

      <div className="benefits-section">
        <h1 className="section-title">
          에이콘 자비 출판의 장점은 무엇인가요?
        </h1>
        <div className="benefits-grid">
          <div className="benefit-column">
            <div className="benefit-card-header">
              <h3>오랜 출판 경험</h3>
            </div>
            <div className="benefit-card-body">
              <h4>30년간의 전문성</h4>
              <p>IT/경제경영 분야에서 쌓아온 깊이 있는 전문 지식과 노하우</p>
            </div>
          </div>
          <div className="benefit-column">
            <div className="benefit-card-header">
              <h3>저자사이트 제공(유료)</h3>
            </div>
            <div className="benefit-card-body">
              <ul>
                <li>진행사항 관리: 출간 과정 실시간 모니터링</li>
                <li>판매 현황 확인: 실시간 판매 데이터 조회</li>
                <li>인세 정산: 자동 정산 및 세무 서류 제공</li>
                <li>커뮤니티 지원: 저자 간 정보 교류 및 네트워킹</li>
                <li>저술 업무 지원: 저술 참조 자료, 독자 소통 기능 등</li>
              </ul>
            </div>
          </div>
          <div className="benefit-column">
            <div className="benefit-card-header">
              <h3>전문 인력의 컨설팅 제공</h3>
            </div>
            <div className="benefit-card-body">
              <h4>왜 출판 컨설팅이 필요한가요?</h4>
              <ul>
                <li>초보자 실수 방지 (부적절한 표지 디자인, 유통 미준비 등)</li>
                <li>시간과 비용 절감 (불필요한 시행착오 감소)</li>
                <li>
                  경쟁력 있는 책 제작 (독자 니즈 반영, 전문적 퀄리티 보장)
                </li>
                <li>내용, 편집, 디자인의 완성도 향상</li>
                <li>출판 후 마케팅 방향 구체화</li>
                <li>유통 채널 확보와 전략적 연결</li>
              </ul>
              <button
                className="detail-button"
                onClick={handleClick} // 출판 컨설팅 탭으로 이동
              >
                출판 컨설팅 자세히보기
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="recommended-for-container">
        <h1 className="section-title">
          자비 출판, 이런 분들에게 추천합니다!
        </h1>
        <div className="recommended-for-grid">
          {recommendedForData.map((item, index) => (
            <div key={index} className="recommended-for-card">
              <p>{item}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="prepare-section-wrapper">
        <div className="what-to-prepare-container">
          <h1 className="section-title">
            자비 출판, 무엇을 준비해야 하나요?
          </h1>
          <div className="what-to-prepare-grid">
            {whatToPrepareData.map((item, index) => (
              <div key={index} className="prepare-column">
                <div className="prepare-card">
                  <h3>{item.title}</h3>
                </div>
                <p className="prepare-description">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <ComparisonTable highlightedColumn="self" />
    </section>
  );
};

export default AcornSelfPublishing;
